import { useEffect } from "react"

import { Typography } from "antd"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import Private from "../../../../../Components/Private"
import Table from "../../../../../Components/Table"
import { formatCurrency } from "../../../../../Utils/utils"
import { getOutsiderWithdrawalsHistory } from "../../../redux/referrals.thunks"

import "./WithdrawalsHistory.less"

dayjs.extend(utc)

const { Text } = Typography

const statusColorsMap = {
  Successful: "#35BD29",
  Pending: "#661AC6",
  Failed: "#D71313"
}

const statusBadgeMap = {
  Successful: { bg: "#D7F7C2", color: "#006908" },
  Pending: { bg: "#F6F0FF", color: "#460D90" },
  Failed: { bg: "#FFF4F4", color: "#9E1414" }
}

export const WithdrawalsHistoryTable = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const isMobile = useSelector((state) => state.nav.isMobile)
  const { outsiderWithdrawalsHistory } = useSelector((state) => state.referrals)

  useEffect(() => {
    dispatch(getOutsiderWithdrawalsHistory())
  }, [])

  if (isMobile) {
    return (
      <div className="withdrawals-history-cards">
        {(outsiderWithdrawalsHistory ?? []).map((record, i) => {
          const badge = statusBadgeMap[record.status] ?? {
            bg: "#F4F4F5",
            color: "#7A7A83"
          }
          const dateStr = record.date_utc
            ? dayjs(record.date_utc).utc().format("D MMM YYYY h:mm A") + " (UTC)"
            : "—"
          return (
            <div key={i} className="withdrawals-history-cards__card">
              <div className="withdrawals-history-cards__badge" style={{ background: badge.bg }}>
                <span style={{ color: badge.color }}>{record.status}</span>
              </div>
              <div className="withdrawals-history-cards__row">
                <div className="withdrawals-history-cards__field">
                  <span className="withdrawals-history-cards__label">{t("Credit card")}</span>
                  <span className="withdrawals-history-cards__value">
                    {record.withdrawn_to || "—"}
                  </span>
                </div>
                <div className="withdrawals-history-cards__field">
                  <span className="withdrawals-history-cards__label">{t("Amount")}</span>
                  <span className="withdrawals-history-cards__value">
                    {formatCurrency(record.amount_cents / 100)}
                  </span>
                </div>
              </div>
              <div className="withdrawals-history-cards__field">
                <span className="withdrawals-history-cards__label">{t("Date")}</span>
                <span className="withdrawals-history-cards__value">{dateStr}</span>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <Table
      scroll={{}}
      dataSource={outsiderWithdrawalsHistory ?? []}
      columns={[
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          width: 156,
          render: (_, record) => (
            <Text strong style={{ color: statusColorsMap[record.status] }}>
              {record.status}
            </Text>
          )
        },
        {
          title: "Withdrawn to",
          dataIndex: "withdrawn_to",
          key: "withdrawn_to",
          render: (_) => (_ ? <Private>{_}</Private> : "-")
        },
        {
          title: "Amount",
          dataIndex: "amount_cents",
          key: "amount_cents",
          align: "end",
          width: 156,
          render: (_, record) => (
            <Text strong style={{ textAlign: "end" }}>
              <Private>{formatCurrency(record.amount_cents / 100)}</Private>
            </Text>
          )
        },
        {
          title: "Date",
          dataIndex: "date",
          key: "date",
          render: (_, record) => (
            <Text strong>
              {dayjs(record?.date_utc).utc().format("D MMM YYYY h:mm A") + " (UTC)"}
            </Text>
          )
        }
      ]}
      expandable={{ defaultExpandAllRows: true }}
      withOutPagination
    />
  )
}

export default WithdrawalsHistoryTable
